const data = [
  { title: 'Department of Income Tax', link : 'https://incometaxindiaefiling.gov.in/home'},
  { title: 'Goods and Services Tax', link : 'https://www.gst.gov.in/'},
  { title: 'GST Law', link : 'https://services.gst.gov.in/services/gstlaw/gstlawlist'},
  { title: 'GST Payments Quick Links', link : 'https://services.gst.gov.in/services/quicklinks/payments'},
  { title: 'ITR Status', link : 'https://incometaxindiaefiling.gov.in/e-Filing/Services/ITRStatusLink.html?lang=eng'},
  { title: 'Highlights of PM Narendra Modi g Speech on CA Day at ICAI Event', link : 'https://www.youtube.com/watch?v=OhHqzzgYrDE'},
  { title: 'E-Way Bill System', link : 'https://www.youtube.com/channel/UCFYpOk92qurlO5t-Z_y-bOQ'},
  { title: 'CA Work Management', link : 'https://www.youtube.com/watch?v=1mo11AGye5k'},
  { title: 'Personal Finance News/budget-2018', link : 'https://economictimes.indiatimes.com/wealth/personal-finance-news/budget-2018-heres-how-much-the-tax-reliefs-you-want-will-cost-the-finance-minister/articleshow/62671216.cms'},
  { title: 'Linked In -Chachan & Lath', link : 'https://www.linkedin.com/company/chachan-&-lath'},

];
export default data;



// WEBPACK FOOTER //
// ./src/NewsCentre/data.js